@if (displayFrontPage) {
    <div>
        <div class="my-16 flex justify-center">
            <div class="mt-20">
                <div class="text-center items-center">
                    <div class="mt-1 mb-4">
                        <img style="max-width: 50% !important" class="inline" src="/assets/images/buzzer/buzzer-16x9.png" alt="No data" />
                    </div>
                    <div class="mb-6">
                        <h4>{{ "addons_front_title" | translate }}</h4>
                        <p [innerHTML]="'addons_front_text' | translate"></p>
                    </div>
                    <div class="p-fluid mt-6 mb-16 flex justify-center">
                        <div style="min-width: 80px; max-width: 80px" class="mr-6">
                            <p-inputNumber
                                class="upgrade-fix-input-number input-number-width-80"
                                [(ngModel)]="addBuzzerQuantity"
                                [showButtons]="true"
                                [min]="1"
                                inputId="stacked"
                            />
                        </div>
                        <div style="width: 30%">
                            <button pButton pRipple type="button" class="w-full" (click)="goToBuyBuzzer()">
                                {{ "button_addons_hardware_addtocart_linktext" | translate }}
                            </button>
                        </div>
                    </div>

                    <div class="mb-8">
                        <span class="mb-20" style="color: #818181">
                            {{ "addons_hardware_status" | translate }}:
                            <span style="color: #1bcf85; font-weight: 600">{{ "addons_hardware_in_stock" | translate }}</span>
                            •
                        </span>
                        <a class="link" style="color: #818181" (click)="toggleFrontDisplay()">
                            <u>{{ "addons_front_footer" | translate }}</u>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
} @else {
    <div>
        <div class="mx-2 mt-6 mb-2">
            <div class="m-8">
                <h4>{{ "addons_extend_heading" | translate }}</h4>
                <p>{{ "addons_extend_description" | translate }}</p>
            </div>
        </div>

        <div class="mt-12 mb-20" style="max-width: 1500px">
            <div class="m-4">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12 lg:col-span-12 xl:col-span-8">
                        <div class="box card">
                            <div class="grid grid-cols-12 gap-4">
                                <div class="col-span-12 lg:col-span-4">
                                    <div class="box">
                                        <img
                                            style="margin-top: 50px; max-width: 100% !important; max-height: 300px"
                                            alt="Buzzer"
                                            src="/assets/images/buzzer/buzzer-1x1.png"
                                        />
                                    </div>
                                </div>
                                <div class="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-8">
                                    <div class="m-4">
                                        <h5>
                                            {{ "addons_hardware_heading" | translate }}<br />
                                            <span style="color: #818181">{{ "addons_hardware_description" | translate }}</span>
                                        </h5>
                                        <p>
                                            {{ "addons_hardware_status" | translate }}:
                                            <span style="color: #179604; font-weight: 700">{{ "addons_hardware_in_stock" | translate }}</span>
                                        </p>
                                        <h5 class="mb-6">{{ "addons_hardware_price" | translate }}: {{ "addons_hardware_price_tag" | translate }}</h5>

                                        <ul class="feature-list">
                                            <li class="mb-6">
                                                <i class="feature-icon pi pi-check-circle"></i>{{ "addons_hardware_description1" | translate }}
                                            </li>
                                            <li class="mb-6">
                                                <i class="feature-icon pi pi-check-circle"></i>{{ "addons_hardware_description2" | translate }}
                                            </li>
                                            <li class="mb-6">
                                                <i class="feature-icon pi pi-check-circle"></i>{{ "addons_hardware_description3" | translate }}
                                            </li>
                                        </ul>

                                        <p>
                                            {{ "addons_hardware_description4" | translate }}
                                            <a href="{{ 'addons_hardware_description_link' | translate }}" target="_blank" rel="noopener">
                                                {{ "addons_hardware_description_linktext" | translate }}
                                            </a>
                                        </p>

                                        <div class="p-fluid mt-8 flex">
                                            <div style="min-width: 80px; max-width: 80px" class="mr-6">
                                                <p-inputNumber
                                                    class="input-number-width-80"
                                                    [(ngModel)]="addBuzzerQuantity"
                                                    [showButtons]="true"
                                                    [min]="1"
                                                    inputId="stacked"
                                                >
                                                </p-inputNumber>
                                            </div>
                                            <div style="width: 100%">
                                                <button pButton pRipple type="button" class="w-full" (click)="goToBuyBuzzer()">
                                                    {{ "button_addons_hardware_addtocart_linktext" | translate }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="m-12">
            <p-divider></p-divider>
        </div>
        <div class="mt-12" style="max-width: 1500px">
            <div class="m-12">
                <div class="mb-12">
                    <h4>{{ "addons_faq_heading" | translate }}</h4>
                    <p>{{ "addons_faq_description" | translate }}</p>
                </div>
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 my-4">
                        <h5>{{ "addons_faq_try_out" | translate }}</h5>
                        <p>
                            {{ "addons_faq_try_line2" | translate }}<br />
                            {{ "addons_faq_try_line3" | translate }}<br />{{ "addons_faq_try_line1" | translate }}
                        </p>
                    </div>
                    <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 my-4">
                        <h5>{{ "addons_faq_how_many" | translate }}</h5>
                        <p>
                            {{ "addons_faq_how_many_line1" | translate }}<br />{{ "addons_faq_how_many_line2" | translate }}
                            <br />
                            {{ "addons_faq_how_many_line3" | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
